<div class="At-SectionNochannel">
  <figure class="At-Image">
    <img src="assets/images/nochannel-img.png" alt="Image Description">
  </figure>
  <div class="At-NoCannelContent">
    <h2>Oooopsss No Channels</h2>
    <div class="At-Description">
      <p>Become a VIP user and create your own channel and invite your friends</p>
    </div>
    <a href="javascript:void(0);" routerLink="/dashboard/subscription" class="At-Btn">BECOME A VIP</a>
  </div>
</div>
